module.exports = __webpack_public_path__ + "static/media/400005_02.c255d02f.png";